<template>
	
<core-card-foot-item>

    <core-card-foot-item-value><span v-html="formatcurrency(value)" :invalid="!value" v-if="value" /></core-card-foot-item-value>

    <core-card-foot-item-label>{{ field.label }}</core-card-foot-item-label>

</core-card-foot-item>

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return (this.item.game.version) ? this.item.game.version.worth.value || this.item.game.worth.value : this.item.game.worth.value

		}

	}

}

</script>

<style scoped>

</style>
